import React, { useEffect, useState } from 'react';
import PaginaImprimir from './PaginaImprimir';

function Imprimir(props) {
    const [reuniones, setReuniones] = useState([]);
    const [readyTriggered, setReadyTriggered] = useState(false);
    const paginar = (lista) => {
        const paginas = [];
        let temp = [];
        let count = 0;

        lista.forEach((r) => { 
            const esMultiLinea = `${r?.empresas?.[0].nombre} - ${r?.empresas?.[1].nombre}`.length >= 42;
            const peso = props.esTodas && !props.esParaEmpresas && esMultiLinea ? 2 : 1;

            // Si el item no entra, cerrar la página antes de pushearlo
            if (count + peso > 13) {
                paginas.push(temp);
                temp = [];
                count = 0;
            }

            temp.push(r);
            count += peso;
        });

        if (temp.length > 0) paginas.push(temp);
        return paginas;
    };



    const agruparPorEmpresaYPaginar = (lista) => {
        const grupos = {};

        lista.forEach((r) => {
            const empresas = r.empresas || [];
            empresas.forEach((e) => {
                const nombre = e?.nombre || 'Sin nombre';
                if (!grupos[nombre]) grupos[nombre] = [];

                // Filtrar datos como pediste
                const otraEmpresa = empresas.find(em => em.nombre !== nombre);
                grupos[nombre].push({
                    horaInicio: r.horaInicio,
                    empresa: { nombre: otraEmpresa?.nombre || 'Sin nombre' },
                    numeroMesa: r.mesa
                });
            });
        });

        let resultado = [];
        Object.keys(grupos).forEach((empresa) => {
            const paginasEmpresa = paginar(grupos[empresa]).map(pagina => ({
                empresaNombre: empresa,
                reuniones: pagina
            }));
            resultado = [...resultado, ...paginasEmpresa];
        });

        return resultado;
    };

    useEffect(() => {
        if (!props.eventoActual?.reuniones) return;
        setReuniones([]);

        if (props.esParaEmpresas) {
            setReuniones(agruparPorEmpresaYPaginar(props.eventoActual.reuniones));
        } else {
            setReuniones(paginar(props.eventoActual.reuniones));
        }
    }, [props.eventoActual, props.esParaEmpresas]);

    useEffect(() => {
        if (!readyTriggered) {
            props.onReady?.();
            setReadyTriggered(true);
        }
    }, [reuniones, readyTriggered, props]);

    useEffect(() => {
        if (!props.reuniones) return;
        setReuniones([]);

        if (props.esParaEmpresas) {
            setReuniones(agruparPorEmpresaYPaginar(props.reuniones));
        } else {
            setReuniones(paginar(props.reuniones));
        }
    }, [props.reuniones, props.esParaEmpresas]);

    return (
        <div id='imprimir' className='d-none w-100 h-100'>
            {reuniones.length > 0
                ? reuniones.map((elem, i) => (
                    <PaginaImprimir
                        key={i}
                        eventoActual={props.eventoActual}
                        reuniones={props.esParaEmpresas ? elem.reuniones : elem}
                        nombreEmpresa={props.esParaEmpresas ? elem.empresaNombre : undefined}
                        esTodas={props.esTodas && !props.esParaEmpresas}
                        esParaEmpresas={props.esParaEmpresas}
                    />
                ))
                : <PaginaImprimir
                    eventoActual={props.eventoActual}
                    reuniones={[]}
                    esTodas={props.esTodas}
                />
            }
        </div>
    );
}

export default Imprimir;
